import { createContext, useContext, useMemo, type ReactNode } from "react";

import { useTelegramWebApp } from "../../hooks/useTelegramWebApp.js";

import { CloudStorageApi } from "./cloud-storage-api.js";
import { CloudStorageDrafts } from "./cloud-storage.js";
import { LocalStorageBackup } from "./local-backup.js";
import type { BackupStorage, DraftStorage } from "./types.js";

interface StorageBundle {
  drafts: DraftStorage;
  backup: BackupStorage;
  cloudAvailable: boolean;
}

const Ctx = createContext<StorageBundle | null>(null);

export function StorageProvider({ children }: { children: ReactNode }) {
  const wa = useTelegramWebApp();
  const value = useMemo<StorageBundle>(() => {
    const api = new CloudStorageApi(wa?.CloudStorage ?? null);
    return {
      drafts: new CloudStorageDrafts({ api }),
      backup: new LocalStorageBackup(),
      cloudAvailable: api.available(),
    };
  }, [wa]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useStorage(): StorageBundle {
  const v = useContext(Ctx);
  if (!v) throw new Error("useStorage must be used inside <StorageProvider>");
  return v;
}
